module.exports = __webpack_public_path__ + "img/Index1Phone.2216c567.png";